


























































































































import { Component, Vue, Prop } from "vue-property-decorator";
import { Form as elForm } from "element-ui";
import axios, { axiosM, resHandle } from "@/plugins/axios";
import Header from "../../components/project-create-header.vue";
import ListCmp from "./listCmp.vue";
import CustomCmp from "./customCmp.vue";
import ControlCmp from "./controlCmp.vue";
import SystemCmp from "./systemCmp.vue";
@Component({
  components: {
    Header,
    ListCmp,
    CustomCmp,
    ControlCmp,
    SystemCmp,
  },
})
export default class ProjectCreateThird extends Vue {
  private projectId: any = "";
  private project: any = {};
  private cZu: any = {};
  private cFangshi: any = {};
  private cTemplate: any = {};
  private zuOpenControl: boolean[] = [true];
  private cState: "list" | "custom" | "control" | "system" = "list";
  /**
   * @description 获取当前项目已有的数据
   */
  private fetch() {
    if (!this.projectId) {
      return;
    }
    const params: any = {
      params: {
        project_id: this.projectId,
      },
    };
    axios.get("api/project/groups", params).then(({ data }) => {
      resHandle(this, data).then(() => {
        this.$set(this.project, "项目分组", data.data);
        this.project.project_id = this.projectId;
        this.cZu = this.project["项目分组"][0];
        this.fetchFangshi();
      });
    });
  }
  /**
   * @description 获得某个分组下的所有访视
   */
  private fetchFangshi() {
    const params: any = {
      params: {
        group_id: this.cZu.group_id,
      },
    };
    axios.get("api/project/interviews", params).then(({ data }) => {
      resHandle(this, data).then(() => {
        this.cZu["访视"] = data.data;
        this.cFangshi = this.cZu["访视"][0];
      });
    });
  }
  /**
   * @description 控制组下面的访视显示
   */
  private triggerFangshiOpen(zu, index) {
    this.cZu = zu;
    this.zuOpenControl = [];
    this.zuOpenControl[index] = !this.zuOpenControl[index];
    this.fetchFangshi();
    this.$forceUpdate();
  }
  /**
   * @description 切换访视
   */
  private changeCFangshi(fangshi: any, zu: any) {
    this.cFangshi = fangshi;
    this.cZu = zu;
    this.cState = "list";
  }
  /**
   * @description 点击某个访视的下拉菜单
   */
  private clickFangshiDropdown(command, fangshi, fangshis) {
    switch (command) {
      case "编辑":
        fangshi.editing = true;
        this.$forceUpdate();
        this.$nextTick().then(() => {
          this.$refs[fangshi.interview_id][0].focus();
        });
        break;
      case "删除":
        this.deleteFangshi(fangshi, fangshis);
        break;
    }
  }
  /**
   * @description 修改访视的名称
   */
  private changeFangshiName(fangshi: any) {
    const params: any = {
      interview_id: fangshi.interview_id,
      project_id: fangshi.project_id,
      group_id: fangshi.group_id,
      访视名称: fangshi["访视名称"],
    };
    axios.post("api/project/interview", params).then(({ data }) => {
      resHandle(this, data).then(() => {
        fangshi.editing = false;
        this.$forceUpdate();
        this.$message.success("修改成功");
        // 这里不能再次请求完整的数据，但是要将这个访视的id重新赋值，以应对新增的情况
        fangshi.interview_id = data.data["interview_id"];
      });
    });
  }
  /**
   * @description 删除一个访视
   */
  private deleteFangshi(fangshi: any, fangshis: any[]) {
    if (fangshis.length === 1) {
      this.$message.warning("每个分组下至少要有一个访视，如需更改请重命名");
      return;
    }
    const params: any = {
      data: {
        interview_id: fangshi.interview_id,
        project_id: this.projectId,
        group_id: this.cZu.group_id,
      },
    };
    axios.delete("api/project/interview", params).then(({ data }) => {
      resHandle(this, data).then(() => {
        this.$message.success("删除成功");
        this.fetchFangshi();
      });
    });
  }
  /**
   * @description 给当前分组添加一个访视
   */
  private addFangshi(zu) {
    if (!zu["访视"]) {
      zu["访视"] = [];
    }
    zu["访视"].push({ 访视名称: "新建访视", editing: true });
    this.$forceUpdate();
    this.$nextTick().then(() => {
      this.$refs["new_fangshi"][0].focus();
    });
  }
  /**
   * @description 创建新访视时实时更新
   */
  private newFangshiInput(e) {
    this.$forceUpdate();
  }
  /**
   * @description 创建一个新的访视
   */
  private createNewFangshi(fangshi: any, zu: any) {
    console.log(zu);
    const params: any = {
      project_id: this.projectId,
      group_id: zu.group_id,
      访视名称: fangshi["访视名称"],
    };
    axios.post("api/project/interview", params).then(({ data }) => {
      resHandle(this, data).then(() => {
        this.$message.success("创建成功");
        this.fetchFangshi();
      });
    });
  }
  /**
   * @description 处理当前右边显示部分变化
   */
  private handleCStateChange(val: any) {
    this.cState = val;
  }
  /**
   * @description 返回第一步修改项目信息
   */
  private back() {
    this.$router.push("/main/project/project-create-second/" + this.projectId);
  }
  /**
   * @description 完成并保存
   */
  private save() {
    this.$message.success("保存成功");
    this.$router.push("/main/project/project-list");
  }
  /**
   * @descripition 从列表跳转自定义模板编辑
   */
  private startCompose(moban) {
    this.cTemplate = moban;
    this.cState = "custom";
  }
  /**
   * @description 初始化
   */
  private beforeMount() {
    this.projectId = this.$route.params.project_id;
    this.fetch();
  }
}
